/* J9 Smart Search — assets/j9-smart-search.js */
(function () {
  'use strict';

  var RECENT_KEY = 'j9s_recent';
  var RECENT_MAX = 6;

  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      localStorage.setItem(RECENT_KEY, JSON.stringify(val));
    } catch (e) { return []; }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function J9Search(root) {
    this.root = root;
    try {
      this.cfg = JSON.parse(root.querySelector('[data-j9s-config]').textContent);
    } catch (e) { return; }
    this.input = root.querySelector('[data-j9s-input]');
    this.form = root.querySelector('[data-j9s-form]');
    this.body = root.querySelector('[data-j9s-body]');
    this.defaultView = root.querySelector('[data-j9s-default]');
    this.resultsView = root.querySelector('[data-j9s-results]');
    this.recentWrap = root.querySelector('[data-j9s-recent-wrap]');
    this.recentList = root.querySelector('[data-j9s-recent]');
    this.trending = root.querySelector('[data-j9s-trending]');
    this.cache = {};
    this.timer = null;
    this.controller = null;
    this.activeIndex = -1;
    this.isOpen = false;
    this.lastTrigger = null;
    this.pushedState = false;
    this.bind();
    this.renderRecent();
  }

  J9Search.prototype.bind = function () {
    var self = this;
    var cfg = this.cfg;

    /* Take over the theme's search icon (capture phase = runs before theme scripts) */
    document.addEventListener('click', function (e) {
      if (!self.alive() || !cfg.triggerSelector || self.root.contains(e.target)) return;
      var t;
      try { t = e.target.closest(cfg.triggerSelector); } catch (err) { return; }
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      self.lastTrigger = t;
      self.open();
    }, true);

    /* Header "Search behaviour: Fire j9h:search-open only" — catches the event
       wherever the header dispatches it (window, document or the icon itself) */
    window.addEventListener('j9h:search-open', function (e) {
      if (!self.alive()) return;
      if (e.preventDefault) e.preventDefault();
      if (e.target && e.target.nodeType === 1) self.lastTrigger = e.target;
      var q = e.detail && typeof e.detail.query === 'string' ? e.detail.query : undefined;
      self.open(q);
    }, true);

    /* Take over other search inputs on the site */
    if (cfg.takeoverInputs && !cfg.isSearchPage) {
      document.addEventListener('focusin', function (e) {
        var el = e.target;
        if (!self.alive() || !el || self.root.contains(el) || el.tagName !== 'INPUT') return;
        var isSearch = el.type === 'search' || (el.name === 'q' && el.closest('form[action*="/search"]'));
        if (!isSearch) return;
        var v = el.value;
        el.blur();
        self.lastTrigger = el;
        self.open(v);
      }, true);
    }

    /* Keyboard shortcut "/" */
    if (cfg.keyboardShortcut) {
      document.addEventListener('keydown', function (e) {
        if (e.key !== '/' || self.isOpen || !self.alive()) return;
        var tag = (document.activeElement && document.activeElement.tagName) || '';
        if (/INPUT|TEXTAREA|SELECT/.test(tag) || document.activeElement.isContentEditable) return;
        e.preventDefault();
        self.open();
      });
    }

    this.root.addEventListener('click', function (e) {
      if (e.target.closest('[data-j9s-close]')) { e.preventDefault(); self.close(); return; }
      if (e.target.closest('[data-j9s-clear]')) { e.preventDefault(); self.setValue(''); self.input.focus(); return; }
      if (e.target.closest('[data-j9s-recent-clear]')) { e.preventDefault(); store(false, []); self.renderRecent(); return; }

      var remove = e.target.closest('[data-j9s-remove]');
      if (remove) {
        e.preventDefault();
        e.stopPropagation();
        var term = remove.getAttribute('data-j9s-remove');
        store(false, store(true).filter(function (x) { return x !== term; }));
        self.renderRecent();
        return;
      }

      var fill = e.target.closest('[data-j9s-fill]');
      if (fill) {
        e.preventDefault();
        self.setValue(fill.getAttribute('data-term') || '');
        self.input.focus({ preventScroll: true });
        return;
      }

      var suggest = e.target.closest('.j9s-suggest');
      if (suggest) self.saveRecent(suggest.getAttribute('data-term'));
      var viewAll = e.target.closest('[data-j9s-viewall]');
      if (viewAll) self.saveRecent(self.input.value.trim());
    });

    this.input.addEventListener('input', function () { self.onInput(); });
    this.input.addEventListener('keydown', function (e) { self.onKeydown(e); });

    this.form.addEventListener('submit', function (e) {
      var active = self.getOptions()[self.activeIndex];
      if (active) { e.preventDefault(); active.click(); return; }
      var q = self.input.value.trim();
      if (!q) { e.preventDefault(); return; }
      self.saveRecent(q);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen) self.close();
    });

    /* Phone back button closes search instead of leaving the page */
    window.addEventListener('popstate', function () {
      if (self.isOpen && self.pushedState) { self.pushedState = false; self.close(true); }
    });

    /* Restore state when returning via browser back (bfcache) */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && self.isOpen) self.close(true);
    });
  };

  J9Search.prototype.alive = function () {
    return document.documentElement.contains(this.root);
  };

  J9Search.prototype.open = function (initial) {
    if (this.isOpen) { this.input.focus(); return; }
    this.isOpen = true;
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('j9s-lock');
    /* focus synchronously so the phone keyboard opens */
    this.input.focus({ preventScroll: true });
    if (typeof initial === 'string' && initial) this.setValue(initial);
    else if (this.input.value) this.input.select();
    this.renderRecent();
    this.startPlaceholder();
    try {
      history.pushState({ j9s: true }, '');
      this.pushedState = true;
    } catch (e) { this.pushedState = false; }
  };

  J9Search.prototype.close = function (fromPop) {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('j9s-lock');
    this.input.blur();
    this.stopPlaceholder();
    if (!fromPop && this.pushedState) {
      this.pushedState = false;
      history.back();
    }
    if (this.lastTrigger && this.lastTrigger.focus && this.lastTrigger.tagName !== 'INPUT') {
      try { this.lastTrigger.focus({ preventScroll: true }); } catch (e) {}
    }
  };

  J9Search.prototype.setValue = function (v) {
    this.input.value = v;
    this.onInput(true);
  };

  J9Search.prototype.onInput = function (immediate) {
    var self = this;
    var q = this.input.value.trim();
    this.root.classList.toggle('has-value', this.input.value.length > 0);
    this.activeIndex = -1;
    clearTimeout(this.timer);

    if (!q) {
      if (this.controller) this.controller.abort();
      this.root.classList.remove('is-loading');
      this.showDefault();
      this.startPlaceholder();
      return;
    }
    this.stopPlaceholder();
    this.timer = setTimeout(function () { self.fetch(q); }, immediate ? 0 : 220);
  };

  J9Search.prototype.fetch = function (q) {
    var self = this;
    var cfg = this.cfg;
    var key = q.toLowerCase();

    if (this.cache[key]) { this.renderResults(this.cache[key]); return; }
    if (this.controller) this.controller.abort();
    this.controller = 'AbortController' in window ? new AbortController() : null;

    if (this.resultsView.hidden || !this.resultsView.firstElementChild) this.showSkeleton();
    this.root.classList.add('is-loading');

    var types = ['product'];
    if (cfg.queryLimit > 0) types.unshift('query');
    if (!this.root.classList.contains('j9s--hide-collections')) types.push('collection');

    var url = cfg.suggestUrl +
      '?q=' + encodeURIComponent(q) +
      '&section_id=' + encodeURIComponent(cfg.sectionId) +
      '&resources[type]=' + types.join(',') +
      '&resources[limit]=' + Math.min(10, Math.max(cfg.productLimit, cfg.queryLimit || 1)) +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

    fetch(url, this.controller ? { signal: this.controller.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = doc.querySelector('.j9s-results');
        if (!results) throw new Error('no results markup');
        self.trim(results);
        self.cache[key] = results.outerHTML;
        if (self.input.value.trim().toLowerCase() === key) self.renderResults(self.cache[key]);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        self.root.classList.remove('is-loading');
        self.resultsView.innerHTML = '';
        self.showDefault();
      });
  };

  /* Apply per-type limits from the theme editor */
  J9Search.prototype.trim = function (results) {
    var cfg = this.cfg;
    var q = results.querySelectorAll('.j9s-suggest-list > li');
    for (var i = cfg.queryLimit; i < q.length; i++) q[i].remove();
    var p = results.querySelectorAll('.j9s-group--products .j9s-card');
    for (var j = cfg.productLimit; j < p.length; j++) p[j].remove();
    var labels = results.querySelectorAll('[data-j9s-label]');
    for (var k = 0; k < labels.length; k++) {
      labels[k].textContent = cfg.labels[labels[k].getAttribute('data-j9s-label')] || '';
    }
  };

  J9Search.prototype.renderResults = function (html) {
    this.root.classList.remove('is-loading');
    this.resultsView.innerHTML = html;
    var res = this.resultsView.querySelector('.j9s-results');

    /* Nothing found: show recommended products underneath */
    if (res && res.getAttribute('data-count') === '0' && this.trending) {
      var main = document.createElement('div');
      main.className = 'j9s__main';
      main.appendChild(this.trending.cloneNode(true));
      res.insertBefore(main, res.querySelector('.j9s-viewall-wrap'));
    }
    if (res) res.classList.add('is-fresh');
    this.defaultView.hidden = true;
    this.resultsView.hidden = false;
    this.body.scrollTop = 0;
  };

  J9Search.prototype.showSkeleton = function () {
    var cells = '';
    var n = window.innerWidth >= 990 ? this.cfg.productLimit : 4;
    for (var i = 0; i < Math.min(n, 8); i++) cells += '<span></span>';
    this.resultsView.innerHTML = '<div class="j9s-skeleton" aria-hidden="true">' + cells + '</div>';
    this.defaultView.hidden = true;
    this.resultsView.hidden = false;
  };

  J9Search.prototype.showDefault = function () {
    this.resultsView.hidden = true;
    this.defaultView.hidden = false;
  };

  /* Keyboard navigation */
  J9Search.prototype.getOptions = function () {
    var view = this.resultsView.hidden ? this.defaultView : this.resultsView;
    return Array.prototype.slice.call(view.querySelectorAll('.j9s-option'));
  };

  J9Search.prototype.onKeydown = function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var opts = this.getOptions();
    if (!opts.length) return;
    e.preventDefault();
    if (opts[this.activeIndex]) opts[this.activeIndex].classList.remove('is-active');
    this.activeIndex += e.key === 'ArrowDown' ? 1 : -1;
    if (this.activeIndex >= opts.length) this.activeIndex = 0;
    if (this.activeIndex < -1) this.activeIndex = opts.length - 1;
    if (this.activeIndex === -1) return;
    var el = opts[this.activeIndex];
    el.classList.add('is-active');
    el.scrollIntoView({ block: 'nearest' });
  };

  /* Recent searches */
  J9Search.prototype.saveRecent = function (term) {
    if (!term || !this.cfg.showRecent) return;
    var list = store(true).filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    store(false, list.slice(0, RECENT_MAX));
  };

  J9Search.prototype.renderRecent = function () {
    if (!this.recentWrap) return;
    var list = store(true) || [];
    if (!list.length) { this.recentWrap.hidden = true; this.recentList.innerHTML = ''; return; }
    var html = '';
    for (var i = 0; i < list.length; i++) {
      var t = escapeHtml(list[i]);
      html += '<a class="j9s-chip j9s-option" href="' + this.cfg.searchUrl + '?q=' + encodeURIComponent(list[i]) + '" data-term="' + t + '" data-j9s-fill>' +
        '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M12 7.5V12l3 2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
        '<span>' + t + '</span>' +
        '<button type="button" class="j9s-chip__remove" data-j9s-remove="' + t + '" aria-label="Remove ' + t + '">' +
        '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></a>';
    }
    this.recentList.innerHTML = html;
    this.recentWrap.hidden = false;
  };

  /* Rotating placeholder: "Search for 'Mini dress'" */
  J9Search.prototype.startPlaceholder = function () {
    var self = this;
    var cfg = this.cfg;
    this.stopPlaceholder();
    if (!cfg.animatePlaceholder || !cfg.popular || !cfg.popular.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    var set = function () {
      self.input.classList.add('is-swapping');
      setTimeout(function () {
        self.input.placeholder = (cfg.placeholderPrefix ? cfg.placeholderPrefix + ' ' : '') + '“' + cfg.popular[i % cfg.popular.length] + '”';
        self.input.classList.remove('is-swapping');
        i++;
      }, 250);
    };
    this.phTimer = setInterval(set, 2600);
  };

  J9Search.prototype.stopPlaceholder = function () {
    clearInterval(this.phTimer);
    this.input.classList.remove('is-swapping');
    if (!this.input.value) this.input.placeholder = this.cfg.placeholder;
  };

  function init() {
    var roots = document.querySelectorAll('[data-j9s]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__j9s) roots[i].__j9s = new J9Search(roots[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-init when the section is changed */
  document.addEventListener('shopify:section:load', init);
})();